var path = 'areas/tasks/views/log_line.html';
var html = "<div class=log-line ng-class=\"[event.Category, {'full-date': fullDate }]\"> <div class=log-time title=\"{{ event.OccurredAt | moment }}\"> {{ event.OccurredAt | moment:dateFormat }} </div> <div class=log-category>{{ event.Category }}</div> <div class=log-message>{{ detail =='true' ? detailedMessage : summaryMessage }}</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/views/log_line.html
// module id = 3278300256529623
// module chunks = 1